import { CommonModule, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, of, take } from 'rxjs';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { CustomerDashboardCounter } from '../../models/domain/CustomerDashboardCounter';
import { RoleEnum } from '../../models/enums/RoleEnum';
import { AuthenticationService } from '../../services/authentication.service';
import { CustomerDashboardcounterService } from '../../services/CustomerDashboardcounterService';
import { LoadingService } from '../../services/loading.service';
import { AverageOrderValueComponent } from './average-order-value/average-order-value.component';
import { OrderStatsComponent } from './order-stats/order-stats.component';
import { RecentOrdersComponent } from './recent-orders/recent-orders.component';
import { TotalDiscountComponent } from './total-discount/total-discount.component';
import { TotalSalesComponent } from './total-sales/total-sales.component';
import { TotalTransactionsComponent } from './total-transactions/total-transactions.component';

@Component({
    selector: 'app-pos-system',
    imports: [CommonModule, NgIf, TotalSalesComponent, TotalTransactionsComponent, AverageOrderValueComponent, TotalDiscountComponent, OrderStatsComponent, RecentOrdersComponent], //SmartCacheDashboardComponent, , , , , SalesAnalyticsComponent, CustomerSegmentationComponent, CategoriesComponent, OrderDetailsComponent
    templateUrl: './pos-system.component.html',
    styleUrl: './pos-system.component.scss'
})
export class PosSystemComponent {

    public dashboardCounter = new CustomerDashboardCounter();
    public RoleEnum = RoleEnum;

    constructor(public themeService: CustomizerSettingsService,
        public customercounterService: CustomerDashboardcounterService,
        private loadingService: LoadingService,
        private toasterService: ToastrService,
        private authService: AuthenticationService) {
    }
    ngOnInit(): void {
        this.getData();
    }
    public hasRoles(roles: string[]): boolean {
        return this.authService.hasRoles(roles, true);
    }

    private getData(): void {
        this.loadingService.showLoading();
        this.customercounterService.getCounter().pipe(
            take(1),
            catchError((error) => {
                if (error && error.error) {
                    if (error.error.isCustom) {
                        this.toasterService.warning(error.error.message);
                    } else {
                        this.toasterService.error('Something went wrong!');
                    }
                } else {
                    this.toasterService.error('Something went wrong!');
                }
                return of(null);
            }),
            finalize(() => {
                this.loadingService.hideLoading();
            }),
        ).subscribe(result => {
            if (result && result.body) {
                this.dashboardCounter = result.body;
            }
            this.loadingService.hideLoading();
        });
    }
}